import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, problemsData, seriesData, seriesOtherData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KAccordion, KScrollspy } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const anchorBarHandler = () => {
  const anchorBar = $('.series__anchor .anchorBar.fixed');
  const visibleSection = $('.series__category');
  const hiddenSection = $('.faq');
  const detectVisibility = () => {
    const scrollTop = $(window).scrollTop();
    // 錨點選單
    if (
      scrollTop >= Math.round(visibleSection.offset().top) &&
      scrollTop < Math.round(hiddenSection.offset().top) - anchorBar.innerHeight()
    ) {
      anchorBar.addClass('show');
    } else {
      anchorBar.removeClass('show');
    }
  };

  const anchorBars = Array.from(document.querySelectorAll('.series__anchor .anchorBar'));
  anchorBars.forEach(element => {
    const anchorBarItems = element.querySelector('.anchorBar__items');
    const anchorNavPrev = element.querySelector('.anchorBar__nav.prev');
    const anchorNavNext = element.querySelector('.anchorBar__nav.next');
    let anchorBarW = anchorBarItems.clientWidth;
    let anchorBarScrollW = anchorBarItems.scrollWidth;
    let anchorBarScrollLeft = anchorBarItems.scrollLeft;
    anchorNavPrev.classList.add('hidden');
    if (anchorBarScrollW <= anchorBarW) {
      anchorNavNext.classList.add('hidden');
    }
    const scrollHandler = () => {
      anchorBarW = anchorBarItems.clientWidth;
      anchorBarScrollW = anchorBarItems.scrollWidth;
      anchorBarScrollLeft = anchorBarItems.scrollLeft;
      if (anchorBarItems.scrollLeft <= 0) {
        anchorNavPrev.classList.add('hidden');
      } else {
        anchorNavPrev.classList.remove('hidden');
      }
      if (anchorBarW + anchorBarScrollLeft >= anchorBarScrollW) {
        anchorNavNext.classList.add('hidden');
      } else {
        anchorNavNext.classList.remove('hidden');
      }
    };
    const anchorMoveHandler = nav => {
      anchorBarW = anchorBarItems.clientWidth;
      anchorBarScrollW = anchorBarItems.scrollWidth;
      anchorBarScrollLeft = anchorBarItems.scrollLeft;
      const distance = nav === 'prev' ? anchorBarScrollLeft - anchorBarW : anchorBarScrollLeft + anchorBarW;
      gsap.to(anchorBarItems, {
        scrollTo: {
          x: distance,
        },
        duration: 0.3,
        ease: 'ease-in-out',
      });
    };
    anchorBarItems.addEventListener('scroll', scrollHandler);
    anchorNavPrev.addEventListener('click', () => anchorMoveHandler('prev'));
    anchorNavNext.addEventListener('click', () => anchorMoveHandler('next'));
  });

  $(window).on('scroll', detectVisibility);
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });
  const accordion = new KAccordion('[k-accordion]', {
    onOpenAnchor: false,
  });
  const scrollspy = new KScrollspy('[k-scrollspy]', {
    onEnter: scrollspyID => {
      const anchorBars = Array.from(document.querySelectorAll('.series__anchor .anchorBar'));
      anchorBars.forEach(anchorBar => {
        const anchorBarItems = anchorBar.querySelector('.anchorBar__items');
        const anchorBarW = anchorBarItems.clientWidth;
        const hasHorizontalScrollbar = element => element.scrollWidth > element.clientWidth;
        if (hasHorizontalScrollbar(anchorBarItems)) {
          const anchorItem = anchorBarItems.querySelector(`.anchorBar__item[k-scrollspy-href="${scrollspyID}"]`);
          const itemW = anchorItem.clientWidth;
          const itemOffsetLeft = anchorItem.offsetLeft;
          const distance = itemOffsetLeft + itemW / 2 - anchorBarW / 2;
          gsap.to(anchorBarItems, {
            scrollTo: {
              x: distance,
            },
            duration: 0.6,
            ease: 'ease-in-out',
          });
        }
      });
    },
  });

  anchorBarHandler();
  gsapAnimation();
};

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const problemsDataRef = ref(problemsData);
    const seriesDataRef = ref(seriesData);
    const seriesOtherDataRef = ref(seriesOtherData);
    const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      problemsDataRef,
      seriesDataRef,
      seriesOtherDataRef,
      reportDataRef,
    };
  },
}).mount('#main');
